import { render, staticRenderFns } from "./largesScreen5.vue?vue&type=template&id=1edf340f&scoped=true"
import script from "./largesScreen5.vue?vue&type=script&lang=js"
export * from "./largesScreen5.vue?vue&type=script&lang=js"
import style0 from "./largesScreen5.vue?vue&type=style&index=0&id=1edf340f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf340f",
  null
  
)

export default component.exports